import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import PublicLayout from "@/pages/public/PublicLayout";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import Home from "@/pages/public/Home";
import AttorneyProfile from "@/pages/public/AttorneyProfile";
import PracticeAreas from "@/pages/public/PracticeAreas";
import BlogList from "@/pages/public/BlogList";
import BlogDetail from "@/pages/public/BlogDetail";
import Contact from "@/pages/public/Contact";
import BookConsultation from "@/pages/public/BookConsultation";
import Login from "@/pages/public/Login";
import DesignSystem from "@/pages/design/DesignSystem";
import Overview from "@/pages/dashboard/Overview";
import Clients from "@/pages/dashboard/Clients";
import ClientDetail from "@/pages/dashboard/ClientDetail";
import Documents from "@/pages/dashboard/Documents";
import Cases from "@/pages/dashboard/Cases";
import Appointments from "@/pages/dashboard/Appointments";
import BlogAdmin from "@/pages/dashboard/BlogAdmin";
import BlogEditor from "@/pages/dashboard/BlogEditor";
import ProfileAdmin from "@/pages/dashboard/ProfileAdmin";
import Settings from "@/pages/dashboard/Setting";
import Notifications from "@/pages/dashboard/Notification";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen bg-ivory flex items-center justify-center" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-gold" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route index element={<Home />} />
              <Route path="/attorney" element={<AttorneyProfile />} />
              <Route path="/practice-areas" element={<PracticeAreas />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/book-consultation" element={<BookConsultation />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/design-system" element={<DesignSystem />} />
            <Route path="/dashboard" element={<Protected><DashboardLayout /></Protected>}>
              <Route index element={<Overview />} />
              <Route path="clients" element={<Clients />} />
              <Route path="clients/:id" element={<ClientDetail />} />
              <Route path="documents" element={<Documents />} />
              <Route path="cases" element={<Cases />} />
              <Route path="appointments" element={<Appointments />} />
              <Route path="blog" element={<BlogAdmin />} />
              <Route path="blog/new" element={<BlogEditor />} />
              <Route path="blog/:id/edit" element={<BlogEditor />} />
              <Route path="profile" element={<ProfileAdmin />} />
              <Route path="settings" element={<Settings />} />
              <Route path="notifications" element={<Notifications />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors toastOptions={{ style: { borderRadius: 0 } }} />
      </AuthProvider>
    </div>
  );
}

export default App;
